import React, { Component } from 'react'

export class LetterSvg extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
                id="_x32_"
                width={16}
                height={16}
                viewBox="0 0 512 512"
            >
                <style>{".st0{fill:#EE7100}"}</style>
                <path
                    d="m341.374 265.845 168.152 146.591A56.837 56.837 0 0 0 512 395.853V117.087L341.374 265.845zM256 283.102c7.208-.015 14.31-2.492 20.11-7.538L499.591 80.739c-10.424-13.076-26.458-21.478-44.481-21.478H56.89c-18.023 0-34.057 8.401-44.481 21.478L235.89 275.564c5.792 5.046 12.902 7.523 20.11 7.538zM0 117.087v278.766a56.87 56.87 0 0 0 2.473 16.583l168.152-146.599L0 117.087zM299.474 302.367A66.048 66.048 0 0 1 256 318.655a66.069 66.069 0 0 1-43.474-16.288l-14.845-12.939-174.53 152.151c9.447 6.978 21.092 11.159 33.739 11.159h398.22c12.647 0 24.291-4.181 33.738-11.159l-174.53-152.151-14.844 12.939z"
                    className="st0"
                />
            </svg>
        )
    }
}

export default LetterSvg